import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export interface DownloadLegalFeesInvoiceRequest {
    engagementId: number;
}

export const DownloadLegalFeesInvoice = createAsyncThunk(
    'flowOfFunds/downloadLegalFeesInvoice',
    async (params: DownloadLegalFeesInvoiceRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                `/api/flowOfFunds/${params.engagementId}/legalFees/invoice`,
                { responseType: 'blob' }
            );

            if (response.status !== 200) {
                throw new Error('Failed to download the invoice');
            }

            return response.data as Blob;
        } catch (error) {
            createNotification('Could not download the invoice.', 'error');
            throw error;
        }
    }
);
